<template>
	<div class="mb-3">
		<div class="d-flex align-items-center mb-2">
			<img
				v-if="!card"
				src="images/modal-info.svg"
				alt="Ikona"
				class="mr-2"
				style="transform: rotate(0deg) !important"
			/>
			<h2 class="mb-0" style="line-height: 30px">
				{{ mifidHeader }}
			</h2>
		</div>
		<div
			v-if="
				user.surveyPoolDialogContentType ===
				mifidPopupTypeConst.LackSurvey
			"
			class="mb-3"
		>
			<span style="font-size: 13px !important">
				Wypełnij ankietę MiFID. Pozwoli nam to ocenić, czy usługi, jakie
				dla Ciebie świadczymy oraz instrumenty finansowe, jakie Ci
				oferujemy, są dla Ciebie odpowiednie. Wypełnij ankietę MiFID i
				poznaj swój profil inwestora.
			</span>
		</div>

		<div
			v-else-if="
				user.surveyPoolDialogContentType ===
				mifidPopupTypeConst.SurveyNearExpiry
			"
			class="mb-3"
		>
			<span style="font-size: 13px !important">
				Twoja ankieta MiFID została przez Ciebie wypełniona ostatni raz
				prawie 3 lata temu i wkrótce straci ważność.
				<br />Jeśli tego nie zrobisz, nie będziemy mogli ocenić, czy
				usługi, jakie dla Ciebie świadczymy oraz instrumenty finansowe,
				jakie Ci oferujemy, są dla Ciebie odpowiednie. <br />
				Zaktualizuj ją już teraz.
			</span>
		</div>

		<div
			v-else-if="
				user.surveyPoolDialogContentType ===
				mifidPopupTypeConst.SurveyExpired
			"
			class="mb-3"
			style="font-size: 13px !important"
		>
			Od wypełnienia Twojej ankiety MiFID upłynęły ponad 3 lata. Oznacza
			to, że Twój profil inwestora wygasł. Nie możemy ocenić, czy usługi
			jakie dla Ciebie świadczymy, oraz instrumenty finansowe jakie Ci
			oferujemy, są dla Ciebie odpowiednie. Wypełnij ankietę MiFID i
			poznaj swój profil inwestora: Zaktualizuj ją już teraz.
		</div>
		<div v-if="card">
			<template v-if="user.surveyScoreAcceptable">
				<div style="font-size: 13px !important">
					Posiadasz wypełnioną aktualną ankietę MIFID, jeżeli chcesz
					jeszcze raz dokonać oceny adekwatności usług świadczonych
					przez mBank S.A., kliknij w poniższy link.
				</div>
			</template>
			<template v-else>
				<div style="font-size: 13px !important" class="mb-3">
					<strong
						>Twój dotychczasowy wynik ankiety odpowiedniości lub
						brak jej wypełnienia wskazuje, że usługa mForex (usługa
						maklerska wykonywania zleceń nabycia lub zbycia
						instrumentów finansowych na rynku nieregulowanym OTC)
						jest nieodpowiednia lub może być niezgodna z Twoją
						wiedzą i doświadczeniem inwestycyjnym.
					</strong>
				</div>
				<div style="font-size: 13px !important">
					Prawo zobowiązuje nas do przeprowadzenia oceny
					odpowiedniości oferowanych przez nas usług i produktów
					inwestycyjnych dla danego klienta, w związku z tym prosimy o
					wypełnienie ankiety MiFID, dotyczącej Twojej wiedzy i
					doświadczenia w inwestowaniu, poziomu tolerancji ryzyka,
					sytuacji finansowej oraz celu i horyzontu inwestycyjnego.
					Zebrane informacje wykorzystamy wyłącznie w celu zawarcia
					lub zmiany zawartych przez Ciebie z naszym bankiem umów
					dotyczących usług maklerskich i inwestycyjnych
				</div>
			</template>
		</div>

		<div v-if="user.isCompany" class="mt-3">
			<div style="font-size: 13px !important">
				Skontaktuj się z zespołem mForex jeśli chcesz wypełnić ankietę
				jako klient firmowy:
				<ul style="padding-left: 13px; list-style: disc">
					<li
						style="
							padding: 0px !important;
							background: none !important;
						"
					>
						email - mforex@mbank.pl
					</li>
					<li
						style="
							padding: 0px !important;
							background: none !important;
						"
					>
						telefon - 22 697 47 74
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			mifidPopupTypeConst: {
				LackSurvey: 1,
				SurveyNearExpiry: 2,
				SurveyExpired: 3,
			},
		};
	},
	props: {
		card: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		user() {
			return this.$store.getters.getUser
				? this.$store.getters.getUser
				: false;
		},

		mifidHeader() {
			switch (this.user.surveyPoolDialogContentType) {
				case this.mifidPopupTypeConst.LackSurvey:
					return 'Wypełnij ankietę MiFID ';
				case this.mifidPopupTypeConst.SurveyNearExpiry:
					return 'Twoja ankieta MiFID wkrótce wygaśnie – zaktualizuj ją';
				case this.mifidPopupTypeConst.SurveyExpired:
					return 'Twoja ankieta MiFID wygasła – zaktualizuj ją';
				default:
					return 'ankieta MiFID';
			}
		},
	},
	async beforeMount() {
		await this.$store.dispatch('fetchUserData');
	},
};
</script>
